import Image from "next/legacy/image";
import React from "react";
import {
  KelasLiveSectionContainer,
  KelasLiveUpcomingContainer,
  PaidUserStudentHeading,
  SectionContainerFirstSection,
  SectionContainerSecondSection,
  PaidUserStudentClassHeading
} from "../../paid-user-mobile.styles";
import KelasLiveSectionUpcoming from "public/assets/kelas-live/kelas-live-upcoming.svg";
import { BimbelProIcon } from "../../../assets/bimbel-pro";
import { IUpcomingClassHeroSectionProps } from "./upcoming-class-hero-section.types";

import { useUpcomingHeroSection } from "./use-upcoming-hero-section";
import { CardCarousel } from "components/kelas-live/card-carousel/card-carousel";
import { ClassSession } from "services/api/sessions/sessionService.types";
import { theme } from "styles";
import { Container } from "styles/common/container";
import { UpcomingClassHeroSectionCard } from "./upcoming-class-hero-section-card/upcoming-class-hero-section-card";
import { ClassSessionType } from "components/kelas-live/hooks/use-user-landing/use-user-landing.types";
import { usePastClasses } from "hooks/use-live-classes/use-past-classes";
import { getClassCardTitle, getClassType } from "components/kelas-live/utils";

const UpcomingClassHeroSection: React.FC<IUpcomingClassHeroSectionProps> = ({
  primaryUser,
  modalConfiguration,
  upcomingClasses,
  currentTimestamp,
  mediaBaseUrl,
  setClassSessionModalDetails
}) => {
  const slotOptInDate = modalConfiguration.api.slot_opt_in_date;
  const { pastSessions, isPastSessionsLoading } = usePastClasses(primaryUser);

  const { displayClasses } = useUpcomingHeroSection(upcomingClasses);

  const handleUpcomingCardClick = (classSession: ClassSession) => {
    setClassSessionModalDetails(classSession, ClassSessionType.UPCOMING);
  };

  const getCardTitle = (index: number) => {
    const classType = getClassType(
      displayClasses[index],
      slotOptInDate,
      pastSessions || []
    );

    const classCardTitle = getClassCardTitle(classType, false);

    return classCardTitle;
  };

  return (
    <KelasLiveSectionContainer>
      <Image
        src={KelasLiveSectionUpcoming}
        alt={"upcoming class image"}
        layout="responsive"
        height="420"
        objectFit="cover"
        priority
      />
      <Container>
        <KelasLiveUpcomingContainer>
          <SectionContainerFirstSection>
            <BimbelProIcon />

            <PaidUserStudentHeading>
              {primaryUser.full_name}
            </PaidUserStudentHeading>
          </SectionContainerFirstSection>

          <SectionContainerSecondSection>
            {displayClasses.length === 1 && !isPastSessionsLoading && (
              <>
                <PaidUserStudentClassHeading>
                  Kelasmu di Bimbel CoLearn
                </PaidUserStudentClassHeading>
                <UpcomingClassHeroSectionCard
                  cardPosition={1}
                  classSession={displayClasses[0]}
                  baseMediaURL={mediaBaseUrl}
                  currentTimeStamp={currentTimestamp}
                  handleClick={() => handleUpcomingCardClick(displayClasses[0])}
                  tag={{
                    cardType: getClassType(
                      displayClasses[0],
                      slotOptInDate,
                      pastSessions || []
                    ),
                    title: getCardTitle(0)
                  }}
                />
              </>
            )}
            {displayClasses.length > 1 && !isPastSessionsLoading && (
              <CardCarousel
                title="Kelasmu di Bimbel CoLearn"
                titleMeta={{
                  color: theme.colors.white,
                  fontSize: theme.fontSizes["xl"]
                }}
              >
                {displayClasses.map((classSession: ClassSession, index) => {
                  return (
                    <UpcomingClassHeroSectionCard
                      key={classSession.id}
                      cardPosition={index + 1}
                      classSession={classSession}
                      baseMediaURL={mediaBaseUrl}
                      currentTimeStamp={currentTimestamp}
                      handleClick={() => handleUpcomingCardClick(classSession)}
                      tag={{
                        cardType: getClassType(
                          classSession,
                          slotOptInDate,
                          pastSessions || []
                        ),
                        title: getCardTitle(index)
                      }}
                    />
                  );
                })}
              </CardCarousel>
            )}
          </SectionContainerSecondSection>
        </KelasLiveUpcomingContainer>
      </Container>
    </KelasLiveSectionContainer>
  );
};

export { UpcomingClassHeroSection };
